export interface RadioOption {
  label: string;
  value: null | boolean | number | string;
}
